import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../services/api';

const MARCAS = ['Chevrolet','Volkswagen','Ford','Fiat','Toyota','Honda','Dodge','Jeep','Willys','Alfa Romeo','Mercedes-Benz','BMW','Porsche','Jaguar','Triumph','MG','DKW','Simca','Outra'];
const UFs    = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];
const FOTOS = [
  { name:'foto_frente',        label:'Frente',                dica:'Centralizado, ao nível do capô, fundo limpo.',         icone:'🔲', obrigatorio:true  },
  { name:'foto_traseira',      label:'Traseira',              dica:'Traseira completa, placa visível se possível.',        icone:'🔲', obrigatorio:true  },
  { name:'foto_lateral_esq',   label:'Lateral esquerda',      dica:'Lado do motorista, carro inteiro em quadro.',         icone:'◀️', obrigatorio:true  },
  { name:'foto_lateral_dir',   label:'Lateral direita',       dica:'Lado do passageiro, carro inteiro em quadro.',        icone:'▶️', obrigatorio:true  },
  { name:'foto_painel',        label:'Painel / Cockpit',      dica:'Sentado no banco do motorista, painel completo.',     icone:'🎛️', obrigatorio:true  },
  { name:'foto_banco_traseiro',label:'Banco traseiro',        dica:'Foto do interior traseiro, de dentro ou de fora.',    icone:'🪑', obrigatorio:false },
  { name:'foto_motor',         label:'Motor',                 dica:'Capô aberto, motor visível, bem iluminado.',          icone:'⚙️', obrigatorio:true  },
  { name:'foto_portas',        label:'Portas abertas',        dica:'Todas as portas abertas mostrando o interior.',       icone:'🚪', obrigatorio:false },
  { name:'foto_estepe',        label:'Estepe / Porta-malas',  dica:'Tampa traseira/malas aberta e estepe visível.',       icone:'🔧', obrigatorio:false },
  { name:'fotos_outras',       label:'Detalhes adicionais',   dica:'Cromados, rodas, pintura, plaquetas, badges, etc.',   icone:'📷', obrigatorio:false },
];

const GUIA_FOTOS = [
  { num:'01', angulo:'Frente',           instrucao:'Posicione-se de frente ao carro, ao nível do capô. Enquadre o veículo inteiro com pequena margem nas laterais. Prefira fundo neutro (parede, céu, área aberta).', exemplo:'📸 Fundo limpo · Luz natural · Sem reflexo no capô' },
  { num:'02', angulo:'Traseira',         instrucao:'Repita o processo pelo lado oposto. Certifique-se que a placa, lanternas e para-choque estejam completamente visíveis.', exemplo:'📸 Placa visível · Lanternas nítidas' },
  { num:'03', angulo:'Lateral esquerda', instrucao:'Afaste-se o suficiente para capturar o carro inteiro de perfil. Esse é o ângulo mais importante — use luz natural e evite sombras cortando o carro.', exemplo:'📸 Perfil completo · Rodas dentro do quadro' },
  { num:'04', angulo:'Lateral direita',  instrucao:'Mesma técnica da lateral esquerda, pelo lado do passageiro.', exemplo:'📸 Perfil completo · Rodas dentro do quadro' },
  { num:'05', angulo:'Painel',           instrucao:'Sente-se no banco do motorista e fotografe o painel inteiro. Inclua volante, velocímetro, rádio e acabamentos. Luz natural pela janela ajuda muito.', exemplo:'📸 Sem flash direto · Painel todo visível' },
  { num:'06', angulo:'Banco traseiro',   instrucao:'Abra a porta traseira e fotografe o banco por dentro, mostrando estofamento e espaço. Ou foto de dentro do banco traseiro olhando para frente.', exemplo:'📸 Estofado · Tapetes · Acabamento interno' },
  { num:'07', angulo:'Motor',            instrucao:'Abra o capô e fotografe o compartimento do motor bem iluminado. Limpe o motor antes se possível — faz grande diferença na impressão do comprador.', exemplo:'📸 Motor limpo · Sem reflexo no capô · Luz boa' },
  { num:'08', angulo:'Portas abertas',   instrucao:'Abra todas as portas e fotografe o carro de frente ou de 3/4, mostrando o interior. Evidencia soleiras, maçanetas internas e estado geral.', exemplo:'📸 Todas as portas abertas · Interior visível' },
  { num:'09', angulo:'Estepe',           instrucao:'Abra o porta-malas e mostre o estepe, ferramentas e estado do assoalho. Compradores valorizam saber se o estepe é original e calibrado.', exemplo:'📸 Porta-malas aberto · Estepe visível' },
  { num:'10', angulo:'Detalhes',         instrucao:'Fotografe itens que valorizam o carro: rodas originais, emblemas, plaqueta de identificação, cromados, interior diferenciado, detalhes de restauro.', exemplo:'📸 Badges · Rodas · Detalhes únicos' },
];
const STEPS = ['Seus dados', 'Veículo', 'Fotos', 'Confirmação'];

export default function Vender() {
  const nav = useNavigate();
  const [step, setStep]       = useState(1);
  const [enviando, setEnviando] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro]       = useState('');
  const [aceite, setAceite]   = useState(false);

  const [anunciante, setAnunciante] = useState({ nome:'', whatsapp:'', email:'', cidade:'', estado:'' });
  const [veiculo, setVeiculo]       = useState({
    marca:'', modelo:'', versao:'', ano:'', preco:'', quilometragem:'',
    cambio:'', combustivel:'', cor:'', motor:'', cidade:'', estado:'',
    placa:'', chassi:'',
    descricao:'', estado_conservacao:'bom',
    quitado:false, documentacao_em_dia:false, possui_debitos:false, possui_restricoes:false,
    aceita_negociacao:false, aceita_troca:false,
    original:false, placa_preta:false, restaurado:false, pecas_originais:false,
    historico_manutencao:false, detalhes_pintura:'', detalhes_funilaria:'', detalhes_mecanica:'', observacoes:'',
  });
  const [fotos, setFotos] = useState({});

  const soNumeros = (e) => { e.target.value = e.target.value.replace(/\D/g, ''); };
  const updA = e => setAnunciante(a => ({ ...a, [e.target.name]: e.target.value }));
  const updV = e => setVeiculo(v => ({ ...v, [e.target.name]: e.target.type==='checkbox' ? e.target.checked : e.target.value }));
  const updF = e => setFotos(f => ({ ...f, [e.target.name]: e.target.files }));

  const enviar = async () => {
    if (!aceite) return setErro('Aceite os termos de responsabilidade.');
    setEnviando(true); setErro('');
    try {
      const fd = new FormData();
      Object.entries(anunciante).forEach(([k,v]) => fd.append(`${k}_anunciante`, v));
      fd.append('aceite_termos','true');
      Object.entries(veiculo).forEach(([k,v]) => fd.append(k, v));
      Object.entries(fotos).forEach(([campo, files]) => Array.from(files).forEach(f => fd.append(campo, f)));
      await api.post('/solicitacoes', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSucesso(true);
    } catch (e) { setErro(e.response?.data?.error || 'Erro ao enviar. Tente novamente.'); }
    finally { setEnviando(false); }
  };

  if (sucesso) return (
    <>
      <Navbar />
      <div style={{ background:'var(--cream)', minHeight:'calc(100vh - 112px)', display:'flex', alignItems:'center', justifyContent:'center', padding:40 }}>
        <div style={{ textAlign:'center', maxWidth:480 }}>
          <div style={{ fontSize:60, marginBottom:20 }}>✅</div>
          <div className="eyebrow">Enviado</div>
          <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:30, marginBottom:14 }}>Veículo enviado para análise!</h1>
          <p style={{ color:'var(--ink-muted)', lineHeight:1.7, marginBottom:28 }}>
            Nossa equipe irá analisar as informações. Você será notificado sobre o resultado. A publicação ocorre somente após aprovação da Heritage.
          </p>
          <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
            <Link to="/minhas-solicitacoes" className="btn btn-primary">Ver minhas solicitações</Link>
            <Link to="/veiculos" className="btn btn-outline">Explorar catálogo</Link>
          </div>
        </div>
      </div>
    </>
  );

  // Step indicator
  const StepBar = () => (
    <div style={{ display:'flex', marginBottom:32, background:'#fff', border:'1px solid var(--border)', borderRadius:'var(--r-md)', overflow:'hidden' }}>
      {STEPS.map((s, i) => (
        <div key={s} onClick={() => i+1 < step && setStep(i+1)}
          style={{ flex:1, padding:'13px 0', textAlign:'center', fontSize:11, fontWeight:900, letterSpacing:1, textTransform:'uppercase', cursor: i+1 < step ? 'pointer':'default',
            background: step === i+1 ? 'var(--rust)' : step > i+1 ? 'var(--cream-dark)' : '#fff',
            color:      step === i+1 ? '#fff'       : step > i+1 ? 'var(--rust)' : 'var(--ink-muted)',
            borderRight: i<3 ? '1px solid var(--border)' : 'none' }}>
          {step > i+1 ? '✓ ' : `${i+1}. `}{s}
        </div>
      ))}
    </div>
  );

  return (
    <>
      <Navbar />
      <div style={{ background:'var(--cream)', minHeight:'calc(100vh - 112px)', padding:'48px 0' }}>
        <div className="container" style={{ maxWidth:760 }}>
          <div className="page-header">
            <div className="eyebrow">Área Premium</div>
            <h1 className="section-title">Anunciar meu veículo</h1>
            <div className="gold-rule" />
            <p style={{ color:'var(--ink-muted)', fontSize:14 }}>Preencha os dados do seu veículo. Todo anúncio passa por análise antes de ser publicado.</p>
          </div>

          <StepBar />

          {/* Step 1 — Anunciante */}
          {step === 1 && (
            <div className="card" style={{ padding:'32px 36px' }}>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, marginBottom:24 }}>Seus dados de contato</h2>
              <div className="form-row">
                <div className="form-group"><label>Nome completo *</label><input name="nome" value={anunciante.nome} onChange={updA} required /></div>
                <div className="form-group"><label>WhatsApp *</label><input name="whatsapp" value={anunciante.whatsapp} onChange={updA} onInput={soNumeros} inputMode="numeric" placeholder="11999999999" required /></div>
              </div>
              <div className="form-group"><label>E-mail</label><input name="email" type="email" value={anunciante.email} onChange={updA} /></div>
              <div className="form-row">
                <div className="form-group"><label>Cidade</label><input name="cidade" value={anunciante.cidade} onChange={updA} /></div>
                <div className="form-group"><label>Estado</label><select name="estado" value={anunciante.estado} onChange={updA}><option value="">—</option>{UFs.map(e=><option key={e}>{e}</option>)}</select></div>
              </div>
              <div style={{ display:'flex', justifyContent:'flex-end', marginTop:8 }}>
                <button className="btn btn-primary" onClick={() => setStep(2)} disabled={!anunciante.nome || !anunciante.whatsapp}>Próximo →</button>
              </div>
            </div>
          )}

          {/* Step 2 — Veículo */}
          {step === 2 && (
            <div className="card" style={{ padding:'32px 36px' }}>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, marginBottom:24 }}>Dados do veículo</h2>
              <div className="form-row">
                <div className="form-group"><label>Marca *</label><select name="marca" value={veiculo.marca} onChange={updV} required><option value="">Selecione</option>{MARCAS.map(m=><option key={m}>{m}</option>)}</select></div>
                <div className="form-group"><label>Modelo *</label><input name="modelo" value={veiculo.modelo} onChange={updV} required /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Versão</label><input name="versao" value={veiculo.versao} onChange={updV} /></div>
                <div className="form-group"><label>Ano *</label><input name="ano" type="number" value={veiculo.ano} onChange={updV} min="1900" max="2000" required /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Valor (R$)</label><input name="preco" type="number" value={veiculo.preco} onChange={updV} /></div>
                <div className="form-group"><label>Quilometragem</label><input name="quilometragem" type="number" value={veiculo.quilometragem} onChange={updV} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Câmbio</label><select name="cambio" value={veiculo.cambio} onChange={updV}><option value="">—</option><option value="manual">Manual</option><option value="automatico">Automático</option><option value="outro">Outro</option></select></div>
                <div className="form-group"><label>Combustível</label><select name="combustivel" value={veiculo.combustivel} onChange={updV}><option value="">—</option><option value="gasolina">Gasolina</option><option value="etanol">Etanol</option><option value="flex">Flex</option><option value="diesel">Diesel</option><option value="gnv">GNV</option></select></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Cor</label><input name="cor" value={veiculo.cor} onChange={updV} /></div>
                <div className="form-group"><label>Motor</label><input name="motor" value={veiculo.motor} onChange={updV} placeholder="Ex: 1.6 8v" /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Cidade</label><input name="cidade" value={veiculo.cidade} onChange={updV} /></div>
                <div className="form-group"><label>Estado</label><select name="estado" value={veiculo.estado} onChange={updV}><option value="">—</option>{UFs.map(e=><option key={e}>{e}</option>)}</select></div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Placa <span style={{ fontSize:10, color:'var(--ink-muted)', fontWeight:400, textTransform:'none', letterSpacing:0 }}>(uso interno — não exibida no anúncio)</span></label>
                  <input name="placa" value={veiculo.placa} onChange={updV} placeholder="Ex: ABC-1234" style={{ textTransform:'uppercase' }} />
                </div>
                <div className="form-group">
                  <label>Chassi <span style={{ fontSize:10, color:'var(--ink-muted)', fontWeight:400, textTransform:'none', letterSpacing:0 }}>(uso interno — não exibido no anúncio)</span></label>
                  <input name="chassi" value={veiculo.chassi} onChange={updV} placeholder="Número do chassi" />
                </div>
              </div>
              <div style={{ padding:'10px 14px', background:'rgba(154,86,55,.06)', border:'1px solid var(--border)', borderRadius:'var(--r-sm)', fontSize:12, color:'var(--ink-muted)', lineHeight:1.55, marginBottom:4 }}>
                <strong style={{ color:'var(--ink)' }}>Placa e chassi:</strong> informações usadas pela equipe Heritage na análise interna do anúncio. Esses dados não serão exibidos publicamente.
              </div>
              <div className="form-group"><label>Estado de conservação</label><select name="estado_conservacao" value={veiculo.estado_conservacao} onChange={updV}><option value="otimo">Ótimo</option><option value="bom">Bom</option><option value="regular">Regular</option><option value="restauro">Em restauro</option></select></div>
              <div className="form-group"><label>Descrição</label><textarea name="descricao" value={veiculo.descricao} onChange={updV} rows={4} /></div>

              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, margin:'22px 0 14px' }}>Informações do clássico</h3>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:20 }}>
                {[['original','Original'],['placa_preta','Placa preta'],['restaurado','Restaurado'],['pecas_originais','Peças originais'],['historico_manutencao','Histórico de manutenção'],['quitado','Quitado'],['documentacao_em_dia','Doc. em dia'],['possui_debitos','Possui débitos'],['possui_restricoes','Possui restrições'],['aceita_negociacao','Aceita negociação'],['aceita_troca','Aceita troca']].map(([n,l])=>(
                  <label key={n} className="checkbox-group"><input type="checkbox" name={n} checked={!!veiculo[n]} onChange={updV} /><span style={{ fontSize:14 }}>{l}</span></label>
                ))}
              </div>

              <div className="form-group"><label>Detalhes de pintura</label><textarea name="detalhes_pintura" value={veiculo.detalhes_pintura} onChange={updV} rows={2} /></div>
              <div className="form-group"><label>Detalhes de funilaria</label><textarea name="detalhes_funilaria" value={veiculo.detalhes_funilaria} onChange={updV} rows={2} /></div>
              <div className="form-group"><label>Detalhes de mecânica</label><textarea name="detalhes_mecanica" value={veiculo.detalhes_mecanica} onChange={updV} rows={2} /></div>
              <div className="form-group"><label>Observações</label><textarea name="observacoes" value={veiculo.observacoes} onChange={updV} rows={2} /></div>

              <div style={{ display:'flex', justifyContent:'space-between', marginTop:8 }}>
                <button className="btn btn-outline" onClick={() => setStep(1)}>← Anterior</button>
                <button className="btn btn-primary" onClick={() => setStep(3)} disabled={!veiculo.marca || !veiculo.modelo || !veiculo.ano}>Próximo →</button>
              </div>
            </div>
          )}

          {/* Step 3 — Fotos */}
          {step === 3 && (
            <div>
              {/* Guia de como fotografar */}
              <div style={{ background:'var(--ink)', borderRadius:'var(--r-md)', padding:'28px 32px', marginBottom:24, color:'#fff' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:18 }}>
                  <span style={{ fontSize:22 }}>📷</span>
                  <div>
                    <div style={{ fontSize:10, letterSpacing:2, textTransform:'uppercase', color:'var(--gold)', fontWeight:900, marginBottom:3 }}>Guia Heritage de Fotografia</div>
                    <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, fontWeight:600, margin:0 }}>Como fotografar seu clássico</h2>
                  </div>
                </div>
                <p style={{ fontSize:13, color:'rgba(255,255,255,.65)', lineHeight:1.6, marginBottom:22 }}>
                  Anúncios com fotos completas recebem muito mais interesse. Siga o roteiro abaixo para garantir imagens que valorizam o seu veículo.
                </p>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                  {GUIA_FOTOS.map(g => (
                    <div key={g.num} style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.1)', borderRadius:'var(--r-sm)', padding:'14px 16px' }}>
                      <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                        <span style={{ fontSize:10, fontWeight:900, color:'var(--gold)', letterSpacing:1, flexShrink:0, marginTop:2 }}>{g.num}</span>
                        <div>
                          <div style={{ fontSize:12, fontWeight:900, letterSpacing:.5, textTransform:'uppercase', color:'#fff', marginBottom:4 }}>{g.angulo}</div>
                          <p style={{ fontSize:12, color:'rgba(255,255,255,.6)', lineHeight:1.55, margin:'0 0 6px' }}>{g.instrucao}</p>
                          <span style={{ fontSize:10, color:'rgba(216,189,105,.7)', fontStyle:'italic' }}>{g.exemplo}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop:18, padding:'12px 16px', background:'rgba(216,189,105,.1)', border:'1px solid rgba(216,189,105,.25)', borderRadius:'var(--r-sm)', fontSize:12, color:'rgba(255,255,255,.7)', lineHeight:1.6 }}>
                  <strong style={{ color:'var(--gold)' }}>Dica geral:</strong> sempre use luz natural, de preferência no início da manhã ou fim da tarde. Evite tirar fotos no sol a pino (sombras duras) ou em garagens escuras. Limpe o carro antes — isso faz uma diferença enorme na percepção de valor.
                </div>
              </div>

              {/* Campos de upload */}
              <div className="card" style={{ padding:'28px 32px' }}>
                <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:6 }}>Envio das fotos</h3>
                <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:22, lineHeight:1.6 }}>
                  Campos marcados com <span style={{ color:'var(--rust)', fontWeight:900 }}>*</span> são essenciais para aprovação do anúncio. Os demais são opcionais mas recomendados.
                </p>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                  {FOTOS.map(f => (
                    <div key={f.name} style={{ background: fotos[f.name] ? 'rgba(30,125,71,.05)' : 'transparent', border:`1px solid ${fotos[f.name] ? 'rgba(30,125,71,.25)' : 'var(--border)'}`, borderRadius:'var(--r-sm)', padding:'14px 16px', transition:'.2s' }}>
                      <label style={{ display:'block', fontSize:11, fontWeight:900, letterSpacing:.5, textTransform:'uppercase', color: fotos[f.name] ? '#1e7d47' : 'var(--ink)', marginBottom:4 }}>
                        {f.icone} {f.label}{f.obrigatorio && <span style={{ color:'var(--rust)', marginLeft:4 }}>*</span>}
                      </label>
                      <p style={{ fontSize:11, color:'var(--ink-muted)', margin:'0 0 10px', lineHeight:1.5 }}>{f.dica}</p>
                      <input
                        type="file"
                        name={f.name}
                        onChange={updF}
                        accept="image/*"
                        multiple={['fotos_outras','foto_portas','foto_banco_traseiro'].includes(f.name)}
                        style={{ fontSize:12, width:'100%' }}
                      />
                      {fotos[f.name] && (
                        <span style={{ fontSize:11, color:'#1e7d47', fontWeight:700, marginTop:6, display:'block' }}>
                          ✓ {fotos[f.name].length} foto{fotos[f.name].length > 1 ? 's' : ''} selecionada{fotos[f.name].length > 1 ? 's' : ''}
                        </span>
                      )}
                    </div>
                  ))}
                </div>

                <div style={{ marginTop:18, padding:'12px 16px', background:'var(--cream-dark)', border:'1px solid var(--border)', borderRadius:'var(--r-sm)', fontSize:12, color:'var(--ink-muted)', lineHeight:1.6 }}>
                  <strong style={{ color:'var(--ink)' }}>Formatos aceitos:</strong> JPG, PNG, WEBP · <strong style={{ color:'var(--ink)' }}>Tamanho máximo:</strong> 10MB por foto · <strong style={{ color:'var(--ink)' }}>Resolução recomendada:</strong> mínimo 1200×800px
                </div>

                <div style={{ display:'flex', justifyContent:'space-between', marginTop:20 }}>
                  <button className="btn btn-outline" onClick={() => setStep(2)}>← Anterior</button>
                  <button className="btn btn-primary" onClick={() => setStep(4)}>Próximo →</button>
                </div>
              </div>
            </div>
          )}

          {/* Step 4 — Confirmação */}
          {step === 4 && (
            <div className="card" style={{ padding:'32px 36px' }}>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, marginBottom:18 }}>Confirmação</h2>

              <div style={{ background:'var(--cream-dark)', border:'1px solid var(--border)', borderRadius:'var(--r-md)', padding:20, marginBottom:22, fontSize:14, lineHeight:1.7 }}>
                <strong style={{ display:'block', marginBottom:8 }}>Resumo</strong>
                <strong>{veiculo.marca} {veiculo.modelo} {veiculo.versao}</strong> — {veiculo.ano}<br/>
                {veiculo.preco && <>Valor: R$ {Number(veiculo.preco).toLocaleString('pt-BR')}<br/></>}
                Anunciante: {anunciante.nome} · {anunciante.whatsapp}
              </div>

              <div className="aviso-responsabilidade" style={{ marginBottom:22 }}>
                <strong style={{ fontSize:10, letterSpacing:1.2, textTransform:'uppercase', display:'block', marginBottom:6 }}>Termo de responsabilidade</strong>
                Declaro que sou responsável pelas informações fornecidas e que correspondem à realidade do veículo. Estou ciente de que a Heritage atua apenas como plataforma de divulgação e não participa da negociação, pagamento, entrega ou transferência do veículo. Assumo total responsabilidade pelas informações e condições informadas.
              </div>

              <label className="checkbox-group" style={{ marginBottom:24 }}>
                <input type="checkbox" checked={aceite} onChange={e => setAceite(e.target.checked)} />
                <span style={{ fontSize:14 }}>Li e aceito os termos de responsabilidade acima</span>
              </label>

              {erro && <div className="alert alert-danger">{erro}</div>}

              <div style={{ display:'flex', justifyContent:'space-between' }}>
                <button className="btn btn-outline" onClick={() => setStep(3)}>← Anterior</button>
                <button className="btn btn-primary" onClick={enviar} disabled={!aceite || enviando}>
                  {enviando ? 'Enviando…' : 'Enviar para análise ✓'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
